import script from "./AdvertisersSettingsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertisersSettingsTable.vue?vue&type=script&setup=true&lang=js"

import "./AdvertisersSettingsTable.vue?vue&type=style&index=0&id=45287e78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45287e78"]])

export default __exports__